import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ControlPanelButton from 'components/atoms/controlPanelButton';
import ExclamationIcon from 'components/atoms/icons/exclamation';
import { getPatientCcmStatus, showResult } from 'utils';
import { apiCcmPatientDischarge } from 'services/dataService/ccmResources';
import dataService from 'services/dataService';
import { useDispatch } from 'react-redux';
import UpdatePatientStatusModal from './modal';

const PatientCcmStatusButton = ({ profile, statusOptions }) => {
  const [popup, showPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const buttonRef = useRef();

  const {
    adminPanelPatients: { setPatientCcmStatus },
  } = useDispatch();

  const ccmStatus = getPatientCcmStatus(profile.status);

  const handleSubmit = async (value) => {
    const postData = {
      patientGuid: profile.guid,
      dischargeStatus: value,
    };
    setLoading(true);

    const { error, data } = await dataService.updateOnly(
      apiCcmPatientDischarge(postData.patientGuid),
      { dischargeStatus: postData.dischargeStatus },
    );

    if (error) showResult(error);
    if (data) setPatientCcmStatus(value);

    setLoading(false);
  };

  return (
    <div
      className="admin-patient-header-actions-call patient-status"
      ref={buttonRef}
    >
      <ControlPanelButton
        label="CCM Status"
        icon={ExclamationIcon}
        fillColor={!loading && ccmStatus.color}
        disabled={loading}
        handleClick={() => showPopup(!popup)}
      />
      {popup && (
        <UpdatePatientStatusModal
          togglePopup={showPopup}
          handleClick={handleSubmit}
          statusOptions={statusOptions}
        />
      )}
    </div>
  );
};

PatientCcmStatusButton.propTypes = {
  profile: PropTypes.shape({
    guid: PropTypes.string,
    title: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    covidStatus: PropTypes.string,
    status: PropTypes.string,
    birthDate: PropTypes.string,
  }),
  statusOptions: PropTypes.object,
};

export default PatientCcmStatusButton;
